IREP.pointMeterBand = (function () {
    var options;
    var init = function(initOptions) {
        options = initOptions;
    };
    var ProgressBarAnimation = function () {
        var BlueBar = options.blueBarWidth;
        var BlueProgressTimeline = new TimelineMax();
        var GreyProgressTimeline = new TimelineMax();
        var PointerTimeline = new TimelineMax();

        var BlueWidth = 1;

        while (BlueBar > BlueWidth) {
            BlueProgressTimeline.add(TweenMax.to('#divBlue', 0.01, {
                width: BlueWidth + "px",
                ease: Power2.easeIn
            }));

            PointerTimeline.add(TweenMax.to('#divPointer', 0.01, {
                width: (BlueWidth + 36) + "px",
                ease: Power2.easeIn
            }));

            GreyProgressTimeline.add(TweenMax.to('#divGrey', 0.01, {
                width: (600 - BlueWidth) + "px",
                ease: Power2.easeIn
            }));

            BlueWidth++;
            BlueWidth++;



        }
        TweenMax.to($("#point_meter_metal_icon"), 0.25, { display: "block" })
        TweenMax.from($("#point_meter_metal_icon"), 0.5, { scale: 0, opacity: 0, transformOrigin: "center center", rotationY: 360, delay: 2, marginTop: "15px" })

    };

    return {
        init: init,
        ProgressBarAnimation: ProgressBarAnimation
    };
})();